// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
   width: 100%;
   height: 150px;
   padding: 12px 20px;
   box-sizing: border-box;
   border: 2px solid #ccc;
   border-radius: 4px;
   background-color: #f8f8f8;
   font-size: 16px;
   resize: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/tasks/reject-reason/reject-reason.component.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,aAAa;GACb,kBAAkB;GAClB,sBAAsB;GACtB,sBAAsB;GACtB,kBAAkB;GAClB,yBAAyB;GACzB,eAAe;GACf,YAAY;AACf","sourcesContent":["textarea {\n   width: 100%;\n   height: 150px;\n   padding: 12px 20px;\n   box-sizing: border-box;\n   border: 2px solid #ccc;\n   border-radius: 4px;\n   background-color: #f8f8f8;\n   font-size: 16px;\n   resize: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
